function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1252 8.77504C12.354 8.34509 11.4661 8.17149 10.5898 8.27935C9.71344 8.3872 8.89411 8.77092 8.2502 9.37504C7.97812 9.6508 7.75042 9.96705 7.5752 10.3125C7.2002 10.95 6.5627 11.9625 5.1377 12H4.8002C3.79553 12.1427 2.86271 12.6026 2.1377 13.3125C0.112697 15.4125 0.337697 18.975 2.6627 21.3375C4.9877 23.7 8.5502 23.925 10.6127 21.8625C11.3177 21.149 11.7774 20.2297 11.9252 19.2375C11.954 19.1532 11.9667 19.0641 11.9627 18.975C12.0043 18.4417 12.181 17.9277 12.4763 17.4815C12.7715 17.0354 13.1755 16.6718 13.6502 16.425C14.0089 16.2532 14.3381 16.0253 14.6252 15.75C15.2353 15.1104 15.626 14.2932 15.7406 13.4167C15.8552 12.5402 15.6878 11.65 15.2627 10.875",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.57471 14.2875L20.3622 1.53751C20.9622 0.937512 21.3747 0.412513 21.9372 1.01251L22.9872 2.06251C23.5872 2.66251 23.0247 3.07501 22.4622 3.63751L9.67471 16.425",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.03664 18.133C9.91532 17.2543 9.91532 15.8297 9.03664 14.951C8.15796 14.0723 6.73334 14.0723 5.85466 14.951C4.97598 15.8297 4.97598 17.2543 5.85466 18.133C6.73334 19.0117 8.15796 19.0117 9.03664 18.133Z",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4624 1.53748L4.8374 19.1625",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5249 17.85L6.1499 20.475",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGuitar = function SvgGuitar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuitar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guitar.019b7c01.svg";
export { ForwardRef as ReactComponent };